import { render, staticRenderFns } from "./asociar_evento.vue?vue&type=template&id=47a53617&scoped=true"
import script from "./asociar_evento.vue?vue&type=script&lang=js"
export * from "./asociar_evento.vue?vue&type=script&lang=js"
import style0 from "./asociar_evento.vue?vue&type=style&index=0&id=47a53617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a53617",
  null
  
)

export default component.exports